import RecallMainPage from "./main.container";

export default RecallMainPage;
